import UserProfile from './UserProfile.container';

export default UserProfile;
